export default __webpack_public_path__ + "static/medicare-tablet-1dd1de680feeaf225d2ec156b0650ae0.png";